/* ============================================================
 * NiCOCHiLL — LINEのメールアドレスをチェックアウトに引き継ぐ
 * ============================================================
 *
 * 流れ:
 *   LINE(LIFF) → ?nl=<署名トークン> で着地
 *     → snippets/nicochill-line-capture.liquid がカート属性 `line_link` に保存
 *     → ここが /api/liff-email でトークンを開いてメールアドレスを受け取り
 *     → Storefront API の cartBuyerIdentityUpdate でカートに買い手メールを載せる
 *     → チェックアウトの「メールアドレス」欄が最初から埋まった状態で開く
 *
 * 前提（2026-08-04 実測済み）:
 *   /cart.js の token をそのまま "gid://shopify/Cart/<token>" にすれば
 *   Liquid のカートを Storefront API から更新できる（cart interoperability）。
 *   /checkout は /checkouts/cn/<同じ token> に飛ぶので、buyerIdentity がそのまま効く。
 *
 * 方針:
 *   - 何が失敗しても無言で素通しする。購入導線は絶対に止めない。
 *   - クリックを preventDefault しない（年齢確認ゲートなど既存の capture 処理と
 *     喧嘩させないため）。カート作成・カート表示のタイミングで先回りして適用する。
 *   - sessionStorage に入れるのは «適用済みのカートトークン» だけ。メールは保存しない。
 * ============================================================ */
(function () {
  'use strict';

  var CFG = window.NC_LINE_BUYER || {};
  if (!CFG.sfEndpoint || !CFG.sfToken || !CFG.apiBase) return;
  // リポジトリ側はプレースホルダのまま。ローカルを丸ごと push して差し戻ってしまった場合は
  // 何もせず黙って降りる（scripts/deploy-line-buyer.mjs を再実行すれば直る）。
  if (CFG.sfToken.indexOf('__') === 0) return;
  if (typeof fetch !== 'function') return;

  var APPLIED_KEY = 'nc_line_buyer_applied'; // 値は cart.token（PIIではない）
  var NOTE_ID = 'nc-guest-note';
  var MUTATION =
    'mutation($id:ID!,$b:CartBuyerIdentityInput!){' +
    'cartBuyerIdentityUpdate(cartId:$id,buyerIdentity:$b){' +
    'cart{buyerIdentity{email}} userErrors{message}}}';

  var running = null; // 同時実行を1本にまとめる

  function readApplied() {
    try { return sessionStorage.getItem(APPLIED_KEY); } catch (e) { return null; }
  }
  function writeApplied(cartToken) {
    try { sessionStorage.setItem(APPLIED_KEY, cartToken); } catch (e) { /* private mode */ }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function getEmail(linkToken) {
    return fetch(CFG.apiBase + '/api/liff-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: linkToken })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && d.email) || null; });
  }

  function setBuyerEmail(cartToken, email) {
    return fetch(CFG.sfEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.sfToken
      },
      body: JSON.stringify({
        query: MUTATION,
        variables: { id: 'gid://shopify/Cart/' + cartToken, b: { email: email } }
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var out = d && d.data && d.data.cartBuyerIdentityUpdate;
        if (out && out.userErrors && out.userErrors.length) return false;
        return !!(out && out.cart && out.cart.buyerIdentity && out.cart.buyerIdentity.email);
      });
  }

  /** カートの注記を「LINEのメールで買えます」に差し替える。無ければ何もしない。 */
  function showLineNote(email) {
    var el = document.getElementById(NOTE_ID);
    if (!el || el.dataset.ncLine === '1') return;
    el.dataset.ncLine = '1';
    el.textContent = 'ご購入には会員登録（ログイン）が必要です。LINEと同じメールアドレス（' + email + '）でのログインがおすすめです。';
    el.classList.add('nc-guest-note--line');
    // polish.css は全体 push 運用で他作業を巻き込むため、ここだけインラインで整える
    el.style.color = '#3a322c';
  }

  function apply() {
    if (running) return running;
    running = getCart()
      .then(function (cart) {
        if (!cart || !cart.token || !cart.item_count) return false;

        var linkToken = cart.attributes && cart.attributes.line_link;
        if (!linkToken) return false;

        var alreadyApplied = readApplied() === cart.token;
        var noteMissing = !!document.getElementById(NOTE_ID) &&
          document.getElementById(NOTE_ID).dataset.ncLine !== '1';
        // 適用済みで注記も出ているなら、問い合わせる理由がない
        if (alreadyApplied && !noteMissing) return true;

        return getEmail(linkToken).then(function (email) {
          if (!email) return false;
          showLineNote(email);
          if (alreadyApplied) return true;
          return setBuyerEmail(cart.token, email).then(function (ok) {
            if (ok) writeApplied(cart.token);
            return ok;
          });
        });
      })
      .catch(function () { return false; })
      .then(function (result) { running = null; return result; });
    return running;
  }

  // --- 発火タイミング（どれも購入導線を止めない） ---

  function start() { apply(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // bfcache から戻ったとき（LINE内ブラウザの戻るで起きる）
  window.addEventListener('pageshow', function (e) { if (e.persisted) apply(); });

  // カートに入れた直後 / 購入手続きへ進む直前。preventDefault はしない。
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('button[name="checkout"], button#checkout, a[href*="/checkout"]')) {
      apply();
      return;
    }
    if (t.closest('button[name="add"], [data-nc-add-to-cart]')) {
      // カート生成が終わるのを待ってから
      setTimeout(apply, 1200);
    }
  }, true);
})();
